"use client";

import { usePathname } from "next/navigation";
import Breadcrumbs from "./Breadcrumbs";
import { resolveTrail } from "@/lib/breadcrumbs";

/**
 * Auto-injects breadcrumbs on every page based on pathname.
 * Injected once in layout.tsx — no per-page changes needed.
 * Pages that should not show breadcrumbs are handled by resolveTrail returning null.
 */
export default function AutoBreadcrumbs() {
  const pathname = usePathname();
  const trail = resolveTrail(pathname);

  if (!trail) return null;

  return (
    <div
      className="mx-auto max-w-6xl px-4 pt-4 pb-1"
      role="navigation"
      aria-label="Breadcrumb"
    >
      <Breadcrumbs trail={trail} />
    </div>
  );
}
